import { defineMessages } from 'react-intl';

import { CALM_ONE_LINKS } from '@/utils/deeplinks/deeplinks';

export const messages = defineMessages({
	dailyCalm: {
		id: 'welcome.dailyCalm',
		defaultMessage: 'Daily Calm',
		description: 'The name of our Daily Calm meditation series',
	},
	wonderMatthew: {
		id: 'welcome.wonderMatthew',
		defaultMessage: 'Wonder - Matthew McConaughey',
		description: 'The name of our Sleep Story featuring Matthew McConaughey',
	},
	sevenDays: {
		id: 'welcome.7daysOfCalm',
		defaultMessage: '7 Days of Calm',
		description: 'The name of our 7 Days of Calm meditation series',
	},
	trainMind: {
		id: 'welcome.trainMind',
		defaultMessage: 'Train Your Mind with LeBron James',
		description: 'The name of our LeBron James mental fitness program',
	},
	lifetimeWelcome: {
		id: 'newMemberOffer.welcome.lifetimeTitle',
		defaultMessage: 'Congrats! Your lifetime subscription is active.',
		description: 'Welcome message for members with lifetime subscriptions',
	},
	premiumWelcome: {
		id: 'newMemberOffer.welcome.title',
		defaultMessage: 'Welcome to Calm Premium!',
		description: 'Welcome message for members with Calm Premium subscriptions',
	},
	nonPremiumWelcome: {
		id: 'o2.welcome.title',
		defaultMessage: 'Congrats! Your Calm subscription is active.',
		description: 'Welcome message for members with normal subscriptions',
	},
	getStartedCTA: {
		id: 'newMemberOffer.welcome.pick',
		defaultMessage: 'Get started with a few of our favorites.',
		description: 'Offer the new member some of our best content',
	},
	openAppCTA: {
		id: 'newMemberOffer.welcome.explore',
		defaultMessage: 'Open Calm App',
		description:
			'Ask them to open the app (will either take to web app, or if on mobile will take to mobile app)',
	},
	lifetimeCancelCTA: {
		id: 'contentTileView.premiumConfirmation.cancel',
		defaultMessage:
			// eslint-disable-next-line max-len
			'If you originally subscribed to Calm Premium through iTunes or the Google Play Store, you need to <cancellink>cancel your subscription</cancellink> with them to stop being charged by them in the future. Upgrading to lifetime access through our website does not automatically cancel prior in-app subscription purchases.',
		description: "Explain to the user that web subscriptions can't auto-cancel mobile subscriptions",
	},
});

export const tiles = [
	{
		slug: 'daily-calm',
		tileImage: '/_n/images/premium-confirmation/tile1.webp',
		altTitle: 'Daily Calm',
		message: messages.dailyCalm,
		programId: 'MaL0dPV',
		programTitle: 'Daily Calm',
		sessionType: 'hidden',
		deeplink: CALM_ONE_LINKS.dailyCalm,
	},
	{
		slug: 'wonder',
		tileImage: '/_n/images/premium-confirmation/tile2.webp',
		altTitle: 'Wonder',
		message: messages.wonderMatthew,
		programId: 'v783WD8Oq',
		programTitle: 'Wonder',
		sessionType: 'sleep',
		deeplink: CALM_ONE_LINKS.wonder,
	},
	{
		slug: '7-days-of-calm',
		tileImage: '/_n/images/premium-confirmation/tile3.webp',
		altTitle: '7 Days of Calm',
		message: messages.sevenDays,
		programId: 'qK3IeqhiJP',
		programTitle: '7 Days of Calm',
		sessionType: 'sequential',
		deeplink: CALM_ONE_LINKS.sevenDaysOfCalm,
	},
	{
		slug: 'LeBron',
		tileImage: '/_n/images/premium-confirmation/tile5.webp',
		altTitle: 'Train Your Mind',
		message: messages.trainMind,
		programId: 'Kl8gZDaKoW',
		programTitle: 'Train Your Mind with LeBron James',
		sessionType: 'series',
		deeplink: CALM_ONE_LINKS.lebron,
	},
] as const;
export type PremiumConfirmationTile = (typeof tiles)[number];

export const lifetimeCancelLinks = {
	en: 'https://calmhelp.zendesk.com/hc/en-us/articles/360037871774',
	es: 'https://support.calm.com/hc/es-419/articles/360037871774',
	fr: 'https://support.calm.com/hc/fr/articles/360037871774',
	de: 'https://support.calm.com/hc/de/articles/360037871774',
} as const;
export const isLifetimeCancelLinkLocale = (value: string): value is keyof typeof lifetimeCancelLinks =>
	value in lifetimeCancelLinks;
